export interface IGeoPoint {
  type: 'Point',
  coordinates: [ number, number ]
}
export interface GeoPoint extends IGeoPoint {}

export class GeoPoint {

  constructor(props: IGeoPoint | undefined) {

    Object.assign(this, {
     type: 'Point',
      coordinates: [
        props?.coordinates?.[0] ?? 0,
        props?.coordinates?.[1] ?? 0,
      ]
    })
  }

  public toCoordinates (): [ number, number ] {
    return [ this.coordinates[1], this.coordinates[0] ]
  }
}